/** @jsx jsx */
import { jsx } from 'theme-ui'
import { useTranslate } from '@chordcommerce/gatsby-theme-autonomy'
import CartMeter from '~/components/Cart/Meter'
import { useShippingMeter } from '~/hooks/components/use-shipping-meter'

const CartShippingMeter = () => {
  const {
    cansNeededForFreeShipping,
    eligibleForFreeShipping,
    isEmpty,
    percentage,
  } = useShippingMeter()
  const translate = useTranslate()

  return (
    <CartMeter
      label={
        isEmpty
          ? translate('cart.meters.shipping.empty', {
              amount: cansNeededForFreeShipping,
            })
          : eligibleForFreeShipping
          ? translate('cart.meters.shipping.complete')
          : translate('cart.meters.shipping.incomplete', {
              amount: cansNeededForFreeShipping,
            })
      }
      percentage={percentage}
    />
  )
}

export default CartShippingMeter
